/**
 * Internal Login Page
 * Temporary login page for internal use
 */

import { LoginForm } from '@/modules/auth';

export default function InternalLogin() {
  return (
    <div>
      <h2 className='text-xl font-semibold text-foreground mb-6'>Login</h2>
      <LoginForm />
    </div>
  );
}
